<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
  <span i18n='Club section title@@tixxSelect.sectionHeading.webpageIndividualization' class="esf-action-heading__text">Webpage Individualization</span>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <button class="esf-button esf-button--simple"
              [disabled]="!(selectedLottery.isDraftMode || selectedLottery.isEditMode)"
              (click)="editWebpageIndividualization();$event.stopPropagation();"
              [edsTooltip]="tooltipTranslations.i18nEdit">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-edit"></use>
        </svg>
        <span class="esf-button__icon-text"></span>
      </button>
    </span>
  </span>
</h4>
<div class="esf-info-tile" style="flex: 1">
  <div class="esf-info-tile__content"
       style="display: flex; height: 100%; flex-direction: column; justify-content: space-around;">
    <ng-container *ngIf="!hasAnyContent">
      <section class="esf-empty-state flex-empty-state">
        <div>
          <svg class="esf-icon esf-empty-state__icon" width="32" height="32">
            <use xlink:href="#esf-icon-page-layout"></use>
          </svg>
        </div>
        <p class="esf-paragraph">
          <small i18n='Text for empty state@@customerOverviewComponent.text.noIndividualizationSetup'>No individualization setup yet.</small>
        </p>
      </section>
    </ng-container>

    <ng-container *ngIf="hasAnyContent">

      <div class="esf-icon-and-text esf-icon-and-text--xs hero-image" *ngIf="selectedLottery.event.heroImage">
        <svg class="esf-icon" width="16" height="16">
          <use xlink:href="#esf-icon-circle-check"></use>
        </svg>
        <div class="esf-icon-and-text__text" i18n='@@tixxSelect.text.heroGraphicProvided'>Hero Graphic provided</div>
      </div>
      <div class="esf-icon-and-text esf-icon-and-text--xs guideline-headline" *ngIf="selectedLottery.event.guidelineHeadline">
        <svg class="esf-icon" width="16" height="16">
          <use xlink:href="#esf-icon-circle-check"></use>
        </svg>
        <div class="esf-icon-and-text__text" i18n='@@tixxSelect.text.guidelineHeadlineProvided'>Guideline Headline provided</div>
      </div>
      <div class="esf-icon-and-text esf-icon-and-text--xs guideline-text" *ngIf="selectedLottery.event.guidelineText">
        <svg class="esf-icon" width="16" height="16">
          <use xlink:href="#esf-icon-circle-check"></use>
        </svg>
        <div class="esf-icon-and-text__text" i18n='@@tixxSelect.text.guidelineTextProvided'>Guideline Text provided</div>
      </div>
    </ng-container>

  </div>
</div>
